import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  colors: {
    brand: {
      50: '#e6f2ff',
      100: '#b3d9ff',
      200: '#80bfff',
      300: '#4da6ff',
      400: '#1a8cff',
      500: '#0073e6',
      600: '#0059b3',
      700: '#004080',
      800: '#00264d',
      900: '#000d1a',
    },
    status: {
      open: '#4299E1',      // Blue
      'in-progress': '#ECC94B', // Yellow
      resolved: '#48BB78',   // Green
      closed: '#718096',     // Gray
    },
    priority: {
      low: '#48BB78',        // Green
      medium: '#ECC94B',     // Yellow
      high: '#F56565',       // Red
    },
  },
  fonts: {
    heading: '"Inter", sans-serif',
    body: '"Inter", sans-serif',
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: 'medium',
      },
      variants: {
        solid: (props) => ({
          bg: props.colorScheme === 'brand' ? 'brand.500' : undefined,
          _hover: {
            bg: props.colorScheme === 'brand' ? 'brand.600' : undefined,
          },
        }),
      },
    },
    Card: {
      baseStyle: {
        container: {
          boxShadow: 'md',
          rounded: 'md',
        },
      },
    },
  },
});

export default theme;
